/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { useSelector } from 'react-redux';
import { site } from '@panel/commons/helpers';
import { Step4Module2Validations, Step4Module2ContactValidations } from '../../validations';
import { selectBillingInfo } from '../../../../../ducks/step4Module2';

function PaymentFormProvider({ children }) {
  const { idClienteSap } = useSelector(selectBillingInfo);

  const validate = site.isEcuador ? Step4Module2ContactValidations : Step4Module2Validations;

  const formMethods = useForm({
    resolver: yupResolver(validate),
    mode: 'onBlur',
    submitFocusError: true,
    context: {
      isBillingReadOnly: !!idClienteSap,
      siteId: site.id,
      shouldValidateLocation: site.isBrasil || site.isPeru
    }
  });
  return <FormProvider {...formMethods}>{children}</FormProvider>;
}

export default PaymentFormProvider;
